(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateStoreHours = () => {
      let day;

      try {
        day = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Paris',
          weekday: 'short'
        }).format(new Date());
      } catch (error) {
        return;
      }

      const labels = {
        Mon: 'Aujourd’hui : fermé',
        Tue: 'Aujourd’hui : 9h–13h · 16h–20h',
        Wed: 'Aujourd’hui : 9h–13h · 16h–20h',
        Thu: 'Aujourd’hui : 9h–13h · 16h–20h',
        Fri: 'Aujourd’hui : 9h–13h · 16h–20h',
        Sat: 'Aujourd’hui : 9h–13h · 16h–20h',
        Sun: 'Aujourd’hui : 9h–13h'
      };

      document.querySelectorAll('[data-stef-today]').forEach((label) => {
        label.textContent = labels[day] || 'Horaires de la boutique';
      });
    };

    document.addEventListener('shopify:section:load', updateStoreHours);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateStoreHours();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateStoreHours, {
        once: true
      });
    } else {
      updateStoreHours();
    }

    window.setInterval(updateStoreHours, 60000);
  })();

  } catch(e) { console.error(e); }
})();
})();
